import { combineReducers } from "redux";
import rootCoachDashboardReducer from "./dashboard/rootCoachDashboardReducer";
import rootOnBoardingReducers from "./onBoarding/rootOnBoardingReducer";
export default combineReducers({
  onBoarding: rootOnBoardingReducers,
  coachDashboard : rootCoachDashboardReducer
});
